import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { TbFileInvoice } from "react-icons/tb";
import { TiPencil } from "react-icons/ti";
import InventoryItem from "./InventoryItem";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import CSVUploader from "../../../Common/Uploader";
import TableElement from "../../../Common/TableElement";
import { validateInput, validateFields, showToast, getHeaders } from "../../../utils";
import { csvUrls, defaultCSVHeaders, dropdownDefaultList } from "../../../constants";
import { purchaseInventory } from "../../../actions/inventory";
import { FaX } from "react-icons/fa6";

const checkInventory = (inventoryType, type, deviceModal, simProvider, simStatus) => {
    if (inventoryType === 1) {
        if (!type || !deviceModal || !simProvider || !simStatus) return false;
        return true;
    } else if (inventoryType === 2) {
        if (!type || !deviceModal) return false;
        return true;
    } else {
        if (!type || !simProvider || !simStatus) return false;
        return true;
    }
}

const inventoryItem = {
    isCompleted: false,
    gpsImeiNo: "",
    simImeiNo: "",
    simNum: "",
    simIccidNo: "",
    simTwoNum: "",
    gpsImeiNoErr: false,
    simImeiNoErr: false,
    simNumErr: false,
    simIccidNoErr: false,
    simTwoNumErr: false
}

const inventoryStrt = {
    type: "",
    typeId: null,
    deviceType: "",
    deviceModal: "",
    deviceModalId: "",
    simProvider: "",
    simProviderId: "",
    simStatus: "",
    typeErr: false,
    deviceModalErr: false,
    simProviderErr: false,
    simStatusErr: false,
    isCompleted: false,
    isCsv: false,
    items: [{ ...inventoryItem }]
}
const AddInventory = ({ show, hideModal, data, filterDeviceModal, showSupplier, updateData }) => {
    const initialData = { ...inventoryStrt, items: [{ ...inventoryItem }] }
    const [inventoryIndex, setInventoryIndex] = useState(0);
    const [inventoryItemIndex, setInventoryItemIndex] = useState(0);
    const [inventory, setInventory] = useState([{ ...initialData }]);
    const [transaction, setTransaction] = useState({
        request: false,
        invoiceNo: "",
        invoiceDate: "",
        supplier: "",
        supplierId: "",
        wareHouse: "",
        wareHouseId: "",
        invoiceNoErr: false,
        invoiceDateErr: false,
        supplierErr: false,
        wareHouseErr: false
    });
    const [headerColumn, setHeaderColumn] = useState([]);
    const [fileName, setFileName] = useState("");

    const { request, invoiceNo, invoiceDate, supplier, supplierId, wareHouse, wareHouseId, invoiceNoErr, invoiceDateErr, supplierErr, wareHouseErr } = transaction;
    const { type, typeId, deviceType, deviceModal, simProvider, simStatus, typeErr, deviceModalErr, simProviderErr, simStatusErr, items, isCsv } = inventory[inventoryIndex] || {};

    const inventoryType = typeId == 20 ? 2 : typeId == 21 ? 3 : 1;
    const isAisType = inventoryType == 1 && deviceType == "AIS140";

    const onChangeHandler = (event, isInventory, isItemIndex = null) => {
        const { name, value } = event.target;
        if (isInventory) {
            const temp = [...inventory];
            if (isItemIndex != null) {
                temp[inventoryIndex].items[isItemIndex][name] = value;
                temp[inventoryIndex].items[isItemIndex][`${name}Err`] = null;
            } else {
                temp[inventoryIndex][name] = value;
                temp[inventoryIndex][`${name}Err`] = null;
            }
            setInventory([...temp]);
        } else {
            setTransaction((prev) => ({ ...prev, [name]: value, [`${name}Err`]: null }))
        }
    }

    const onSelectHandler = (event) => {
        const { name, value, isTnxDetails } = event.target;
        if (isTnxDetails) {
            const temp = { [name]: value?.name ?? "", [`${name}Id`]: value?.id ?? "", [`${name}Err`]: null }
            setTransaction(prev => ({ ...prev, ...temp }))
        } else {
            const temp = [...inventory];
            temp[inventoryIndex][name] = value?.name ?? "";
            temp[inventoryIndex][`${name}Id`] = value?.id ?? "";
            temp[inventoryIndex][`${name}Err`] = null;
            if (name == "deviceModal") {
                if (temp[inventoryIndex].isCsv) updateItemsByCsv(null)
                temp[inventoryIndex][`deviceType`] = value?.deviceType ?? "";
                temp[inventoryIndex][`simStatus`] = "";
            }

            if (name == "type") {
                if (temp[inventoryIndex].isCsv) updateItemsByCsv(null)
                filterDeviceModal(value?.id ?? "");
                onSelectHandler({ target: { name: "deviceModal", value: null } });
            }
            setInventory([...temp]);
        }
    }

    const addInventory = (isChecking) => {
        let prevList = [...inventory];
        const updateError = (field, type) => {
            const error = validateInput(prevList[inventoryIndex][field], type);
            if (error) prevList[inventoryIndex][`${field}Err`] = error;
            return error;
        };

        const completeItem = () => {
            prevList[inventoryIndex]["isCompleted"] = true;
            setHeaderColumn(getHeaders(prevList));
            prevList = [...prevList, { ...initialData }];
            setInventory([...prevList]);
            setInventoryItemIndex(0);
            setTimeout(() => setInventoryIndex(prevList.length - 1), 500)
        };
        if (inventoryType === 1) {
            if (
                updateError("type", "text") || updateError("deviceModal", "text") || updateError("simProvider", "text") || updateError("simStatus", "text")) {
                setInventory([...prevList]);
                return;
            }
        } else if (inventoryType === 2) {
            if (updateError("type", "text") || updateError("deviceModal", "text")) {
                setInventory([...prevList]);
                return;
            }
        } else {
            if (updateError("type", "text") ||
                updateError("simProvider", "text") ||
                updateError("simStatus", "text")) {
                setInventory([...prevList]);
                return;
            }
        }

        if (isChecking) return true; // so that we can pass throught to next step
        completeItem();
        setInventory([...prevList]);
    }

    const addItems = (isChecking) => {
        const temp = [...inventory];
        const obj = items[inventoryItemIndex];
        const updateError = (field, type) => {
            const error = validateInput(obj[field], type);
            if (error) temp[inventoryIndex].items[inventoryItemIndex][`${field}Err`] = error;
            return error;
        };

        const completeItem = () => {
            temp[inventoryIndex].items[inventoryItemIndex]["isCompleted"] = true;
            temp[inventoryIndex].items = [...temp[inventoryIndex].items, { ...inventoryItem }];
            setTimeout(() => setInventoryItemIndex(inventoryItemIndex + 1), 500);
        };
        if (inventoryType === 1) {
            if (isAisType) {
                if (
                    updateError("gpsImeiNo", "imei") ||
                    updateError("simImeiNo", "imei") ||
                    updateError("simNum", "phone") ||
                    updateError("simTwoNum", "phone")) {
                    setInventory([...temp]);
                    return;
                }
            } else {
                if (
                    updateError("gpsImeiNo", "imei") ||
                    updateError("simImeiNo", "imei") || updateError("simNum", "phone")) {
                    setInventory([...temp]);
                    return;
                }
            }
        } else if (inventoryType === 2) {
            if (updateError("gpsImeiNo", "imei")) {
                setInventory([...temp]);
                return;
            }
        } else {
            if (
                updateError("simImeiNo", "imei") ||
                (simStatus !== "Blank" && updateError("simNum", "phone"))
            ) {
                setInventory([...temp]);
                return;
            }
        }

        if (isChecking) return true;  // so that we can pass throught to next step

        completeItem();
        setInventory([...temp]);
    };

    const validateInventory = () => {
        if (!addInventory(true)) return;
        else if (!addItems(true)) return;
        else addInventory();
    }

    const validateItems = () => {
        if (!addInventory(true)) return;
        else if (!addItems(true)) return;
        else addItems();
    }

    const updateItemsByCsv = (data, name) => {
        const temp = [...inventory];
        if (data) temp[inventoryIndex].items = data;
        else temp[inventoryIndex].items = [{ ...inventoryItem }]
        temp[inventoryIndex].isCsv = data?.length > 0;
        setFileName(name || "");
        setInventory([...temp]);
    }

    const getPostObj = (add) => {
        const inventoryTypeData = [];
        inventory.forEach(({ typeId, deviceModalId, simProviderId, simStatus, items, isCompleted }) => {
            if (add || (add == false && isCompleted)) {
                const itemsData = [];
                items.forEach(({ gpsImeiNo, simImeiNo, simNum, simIccidNo, simTwoNum }) => {
                    const simInfoTwo = isAisType ? [{ simIccidNo: simImeiNo, simNo: simTwoNum }] : [];
                    itemsData.push({
                        gpsImeiNo,
                        simInfo: typeId == 20 ? null : [{
                            simIccidNo: simImeiNo,
                            simNo: simNum,
                        }, ...simInfoTwo]
                    })
                })
                inventoryTypeData.push({
                    inventoryTypeId: typeId,
                    deviceModalId: deviceModalId || null,
                    simProviderId: simProviderId || null,
                    simStatus: simStatus || null,
                    items: itemsData
                });
            }
        });

        return {
            invoiceNo,
            invoiceDate,
            supplierId,
            warehouseId: wareHouseId,
            inventoryTypeData
        }
    }

    const successApi = (payload) => {
        setTransaction(prev => ({ ...prev, request: true }))
        purchaseInventory(payload).then(response => {
            if (response?.data?.data) {
                if (updateData) updateData()
                showToast(response?.data?.message ?? "", "success");
                setTimeout(hideModal, 2000);
            }
        }).catch(ex => {
            showToast(ex?.response?.data?.message ?? "", "error");
        }).finally(() => {
            setTransaction(prev => ({ ...prev, request: false }));
        })
    }

    const submit = () => {
        const invLength = (inventory?.length ?? 1)
        if (invLength == 1 || inventory[invLength - 1]?.type) {
            validateFields(
                {
                    invoiceNoErr: [invoiceNo, "text"],
                    invoiceDateErr: [invoiceDate, "date"],
                    supplierErr: [supplier, "text"],
                    wareHouseErr: [wareHouse, "text"]
                },
                setTransaction,
                () => {
                    if (!addInventory(true)) return;
                    else if (!addItems(true)) return;
                    else {
                        const payload = getPostObj(true);
                        if (!payload.inventoryTypeData?.length) showToast("Please add the details before submitting!!!", "error"); else successApi(payload);
                    }
                }
            )
        } else {
            validateFields(
                {
                    invoiceNoErr: [invoiceNo, "text"],
                    invoiceDateErr: [invoiceDate, "date"],
                    supplierErr: [supplier, "text"],
                    wareHouseErr: [wareHouse, "text"]
                },
                setTransaction,
                () => {
                    const payload = getPostObj(false);
                    if (!payload.inventoryTypeData?.length) showToast("Please add the details before submitting!!!", "error"); else successApi(payload);
                });
        }
    }

    return <ModalElement FooterComponent={<div className="submit-btn text-center my-2">
        <ButtonElement loading={request} text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" />
    </div>} size="xl" show={show} title={<div className=" flex-md-row flex-column d-flex justify-content-start align-items-center">
        <p className="flex-grow-1">Add Purchase Inventory</p>
        <ButtonElement loading={false} text={"Add Supplier"} cssClass="small-radius small-btn mb-1" onClick={showSupplier} variant="btn-outline-primary" />
    </div>} onHide={hideModal}>
        <div className="add-inventory">
            <div className="transaction-section mb-3">
                <h5 className="mb-3">Transaction Details</h5>
                <div className="row w-100">
                    <div className="col-lg-3 col-md-6 mb-2">
                        <InputElement
                            label={"Invoice Number"}
                            placeholder={"Enter Invoice Number"}
                            name={"invoiceNo"}
                            value={invoiceNo}
                            error={invoiceNoErr}
                            icon={<TbFileInvoice size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                        <InputElement
                            label={"Invoice Date"}
                            placeholder={"Enter Invoice Date"}
                            name={"invoiceDate"}
                            value={invoiceDate}
                            type="date"
                            error={invoiceDateErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <SearchableDropdown
                            label={"Supplier"}
                            placeholder={"Select Supplier"}
                            value={supplier}
                            error={supplierErr}
                            options={data?.suppliers ?? []}
                            onSelect={(value) => onSelectHandler({ target: { name: "supplier", value, isTnxDetails: true } })}
                        />
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <SearchableDropdown
                            label={"WareHouse"}
                            placeholder={"Select WareHouse"}
                            value={wareHouse}
                            error={wareHouseErr}
                            options={data?.wareHouseList ?? []}
                            onSelect={(value) => onSelectHandler({ target: { name: "wareHouse", value, isTnxDetails: true } })}
                        />
                    </div>
                </div>
            </div>

            <div className="inventory-section my-3">
                <h5 className="mb-3">Inventory Details</h5>
                {inventory?.length > 0 && inventory?.[0]?.isCompleted ? <div className="inventory-table mb-3">
                    <TableElement data={inventory} columns={headerColumn} render={(tdData, index) => tdData?.isCompleted ? <tr key={index}>
                        <td>{(index ?? 0) + 1}</td>
                        {headerColumn.slice(0, -2).map((item, index) => <td key={index}>{tdData?.[item.value ?? ""] || "-"}</td>)}
                        <td>{tdData?.items?.length || "-"}</td>
                        <td>
                            <ButtonElement text={<TiPencil size={20} />} cssClass={`small-radius small-btn ${index == inventoryIndex ? "active" : ""}`} onClick={() => {
                                setInventoryIndex(index);
                                setInventoryItemIndex(inventory[index].items.length - 1);
                            }} variant="btn-outline-edit" loading={false} />
                        </td>
                    </tr> : null} />
                </div> : null}
                <div className="row align-items-start">
                    <div className="col-lg-11">
                        <div className="row">
                            <div className={`col-lg-${inventoryType == 1 ? "3" : inventoryType == 2 ? "6" : "4"} col-md-6`}>
                                <SearchableDropdown
                                    label={"Inventory Type"}
                                    placeholder={"Enter Inventory Type"}
                                    value={type}
                                    error={typeErr}
                                    key={inventoryIndex}
                                    options={data.inventoryList}
                                    onSelect={(value) => onSelectHandler({ target: { name: "type", value } })}
                                />
                            </div>
                            {inventoryType != 3 ? <div className={`col-lg-${inventoryType == 1 ? "3" : inventoryType == 2 ? "6" : "4"} col-md-6`}>
                                <SearchableDropdown
                                    label={"Device Modal"}
                                    placeholder={"Select Device Modal"}
                                    value={deviceModal}
                                    error={deviceModalErr}
                                    key={inventoryIndex}
                                    options={data.modelList}
                                    onSelect={(value) => onSelectHandler({ target: { name: "deviceModal", value } })}
                                />
                            </div> : null}
                            {inventoryType != 2 ? <div className={`col-lg-${inventoryType == 1 ? "3" : "4"} col-md-6`}>
                                <SearchableDropdown
                                    label={"Sim Provider"}
                                    placeholder={"Select Sim Provider"}
                                    value={simProvider}
                                    error={simProviderErr}
                                    key={inventoryIndex}
                                    options={data.providerList}
                                    onSelect={(value) => onSelectHandler({ target: { name: "simProvider", value } })}
                                />
                            </div> : null}
                            {inventoryType != 2 ? <div className={`col-lg-${inventoryType == 1 ? "3" : "4"} col-md-6`}>
                                <SearchableDropdown
                                    label={"Sim Status"}
                                    placeholder={"Select Sim Status"}
                                    value={simStatus}
                                    key={inventoryIndex}
                                    error={simStatusErr}
                                    options={inventoryType == 1 ? dropdownDefaultList.simStatus.slice(1) : dropdownDefaultList.simStatus}
                                    onSelect={(value) => onSelectHandler({ target: { name: "simStatus", value } }, true)}
                                />
                            </div> : null}
                        </div>
                    </div>
                    <div className="col-lg-1 text-center">
                        <ButtonElement text={<FaPlus size={"16px"} />} cssClass="small-radius plus-btn" onClick={validateInventory} variant="btn-outline-primary" />
                    </div>
                </div>
            </div>
            {inventory?.[0]?.type ? <>
                <div className="items-section my-2">
                    <h5 className="mb-3">Item Details</h5>
                    <div className={`position-relative ${isCsv ? "uploader" : ""}`}>
                        <CSVUploader acceptType=".csv" icon={<TbFileInvoice size={24} />} expectedHeaders={defaultCSVHeaders.inventory[isAisType ? 4 : inventoryType == 3 ? simStatus == "Blank" ? 5 : 3 : inventoryType]} defaultObj={{ ...inventoryItem, isCompleted: true }} setData={updateItemsByCsv} disable={isCsv ? true : !checkInventory(inventoryType, type, deviceModal, simProvider, simStatus)} />
                        {isCsv ? <div className="position-absolute d-flex justify-content-center align-items-center csv-msg">
                            <p className="px-1 text-start ess mb-0" style={{ fontSize: "16px" }}>{fileName}</p>
                            <FaX size={16} className="cursor-pointer" onClick={(event) => {
                                event.preventDefault();
                                updateItemsByCsv(null);
                            }} /></div> : null}
                    </div>
                    <a href={csvUrls.inventory[isAisType ? 4 : inventoryType == 3 ? simStatus == "Blank" ? 5 : 3 : inventoryType]} download className="action-text-left d-flex justify-content-end mt-2 me-4"> Download Sample CSV </a>
                    {!isCsv ? <div className="divider">
                        <span>OR</span>
                    </div> : null}
                </div>
                {isCsv ? null : items?.length > 0 ? <div className="items-details-section mt-2">
                    {items.map((item, index) => <InventoryItem {...{ inventoryType, isAisType, simStatus, onChangeHandler: (event) => onChangeHandler(event, true, index), addItems: validateItems, ...item }} key={index} />)}</div> : null}
            </> : <div style={{ height: "60px" }}></div>}
        </div>
    </ModalElement>
}

export default AddInventory;